import { Component, OnInit, Input, OnDestroy, ElementRef, Renderer2, Output, NgZone, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { InfoDialogComponent } from "../info-dialog/info-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-survey-dialog',
  templateUrl: './survey-dialog.component.html',
  styleUrls: ['./survey-dialog.component.scss'],
  standalone: false
})
export class SurveyDialogComponent implements OnInit, OnDestroy {
  @Input() dialogObj: any;
  @Input() surveyData: any;
  @Output() openContactEvent = new EventEmitter<any>();
  imagePath: string;
  sanitizedDescription: SafeHtml;

  constructor(
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private el: ElementRef,
    private renderer: Renderer2,
    private headerInfoDialog: MatDialog,
    private ngZone: NgZone) {
  }

  ngOnInit(): void {
    (window as any).angularComponentReference = {
      component: this,
      zone: this.ngZone
    };

    const observer = new MutationObserver(() => {
      // Query for phone, email and webpage links using their respective classes
      const phoneLink = this.el.nativeElement.querySelector('a.phone-link');
      const emailLink = this.el.nativeElement.querySelector('a.email-link');
      const webpageLink = this.el.nativeElement.querySelector('a.webpage-link');

      // If phone link is found, add a listener
      if (phoneLink) {
        this.renderer.listen(phoneLink, 'click', (event: MouseEvent) => {
          this.openContactEvent.emit(`${this.dialogObj?.orgId}#PHONE`);
        });
      }

      // If email link is found, add a listener
      if (emailLink) {
        this.renderer.listen(emailLink, 'click', (event: MouseEvent) => {
          this.openContactEvent.emit(`${this.dialogObj?.orgId}#EMAIL`);
        });
      }

      // If webpage link is found, add a listener
      if (webpageLink) {
        this.renderer.listen(webpageLink, 'click', (event: MouseEvent) => {
          this.openContactEvent.emit(`${this.dialogObj?.orgId}#WEBPAGE`);
        });
      }

      // Disconnect observer at least one link is found
      if (phoneLink || emailLink || webpageLink) {
        observer.disconnect();
      }
    });

    observer.observe(this.el.nativeElement, { childList: true, subtree: true });
  }

  ngOnChanges(): void {
    this.imagePath = this.dialogObj?.ImagePath;
    if (this.dialogObj?.Description) {
      // Translate by default doesn't accept the html property, we need to sanitize it.
      // We also need to tell JS to use the Angular reference version of the function
      this.translate.get(this.dialogObj.Description).subscribe((translated: string) => {
        const replaced = translated.replace(
          /onclick=openDialogModal/g,
          'onclick="window.angularComponentReference.component.openDialogModal();"'
        );

        this.sanitizedDescription = this.sanitizer.bypassSecurityTrustHtml(replaced);
      });
    }
  }

  ngOnDestroy(): void {
    delete (window as any).angularComponentReference;
  }

  openDialogModal() {
    this.ngZone.run(() => {
      let infoDialog = this.dialogObj.InfoDialog;

      const dialogConfig = {
        data: {dialogConfig: infoDialog}
      }

      if (infoDialog["Size"] == "large") {
        dialogConfig['height'] = '85%';
      }

      this.headerInfoDialog.open(InfoDialogComponent, dialogConfig);
    });
  }
}
